import React from "react"
import SocialMediaNavBar from './SocialMediaNavBar'

const Footer = () => {
    return (
        <div className="Footer">
            <h3>Copyright © Gene Campbell III 2020</h3>
            <div className='socialMediaNavBarContainer'>
                <SocialMediaNavBar />
            </div>
        </div>
    )
}

export default Footer